export default function Numpy_Editor() {
  return <div>Numpy_Editor Component</div>;
}
